import AuthorizationWrapper, {
  authFnForMaintenancePages,
  authFnForMaintenanceCreatePages,
} from '@product-framework/components/AuthorizationWrapper';
import { FORM_ACTION, getRoutes } from '@ui-framework/index';
import BrandList from './pages/list/index';
import BrandMaintenance from './pages/upsert/index';
import schema from './schemas/routes.json';
import ErrorPage, { ERROR_PAGE_TYPE } from '../ErrorPage';
import BrandFormStore from './store/index';
import BrandListStore from './store/list';

const Pages = ProtectedRoute => ({
  BrandEdit: (
    <ProtectedRoute
      ErrorPage={ErrorPage}
      ERROR_PAGE_TYPE={ERROR_PAGE_TYPE}
      AuthorizationWrapper={AuthorizationWrapper}
      AuthorizationWrapperProps={{
        authorizationFn: [authFnForMaintenancePages],
      }}
      Component={BrandMaintenance}
      componentProps={{ action: FORM_ACTION.EDIT }}
    />
  ),
  BrandCreate: (
    <ProtectedRoute
      ErrorPage={ErrorPage}
      ERROR_PAGE_TYPE={ERROR_PAGE_TYPE}
      AuthorizationWrapper={AuthorizationWrapper}
      AuthorizationWrapperProps={{
        authorizationFn: [authFnForMaintenanceCreatePages],
      }}
      Component={BrandMaintenance}
      componentProps={{ action: FORM_ACTION.CREATE }}
    />
  ),
  BrandList: (
    <ProtectedRoute
      ErrorPage={ErrorPage}
      ERROR_PAGE_TYPE={ERROR_PAGE_TYPE}
      Component={BrandList}
      AuthorizationWrapper={AuthorizationWrapper}
      AuthorizationWrapperProps={{
        authorizationFn: [authFnForMaintenancePages],
      }}
      ComponentProps={{ action: FORM_ACTION.LIST }}
    />
  ),
});

const routes = ({ ProtectedRoute, BubbleRouteError }) =>
  getRoutes({
    schema,
    ProtectedRoute,
    BubbleRouteError,
    Pages: Pages(ProtectedRoute),
  });

const stores = rootStore => [
  {
    brandFormStore: new BrandFormStore(rootStore),
    brandListStore: new BrandListStore(rootStore),
  },
];

export { BrandList, BrandMaintenance, routes, stores };
